import React, { useState, useContext } from 'react';
import LocalizedLink from './localizedLink';
import { Link } from 'gatsby';
import * as styles from './navPopup.module.css';
import { NavContext } from './NavContext';
import { CSSTransition } from 'react-transition-group';
import { FaWindows, FaApple, FaLinux } from 'react-icons/fa';
import { IoMdClose } from 'react-icons/io';
import useTranslations from '../utils/useTranslations';
import { unlocalizedPageCheck } from '../utils/unlocalizedPageCheck';
import utLogo from '../images/components/navpopup/utorrent-logo-black.svg';

const isBt = process.env.BRAND === 'bt';
const remoteLink = isBt ? 'https://remote.bittorrent.com' : 'https://remote.utorrent.com/';
const neoProductLink = '/products/mac/neo/';
const neoDownloadLink = '/downloads/complete/neo/';

const NavPopup = (props) => {
    const t = useTranslations(props.navText);
    const navContext = useContext(NavContext);

    const handleLanguageClick = (e, value) => {
        props.togglePopup(null);
        let isUnlocalizedPage = unlocalizedPageCheck(props.unlocalizedPath);
        if (isUnlocalizedPage) {
            e.preventDefault();
            sessionStorage.setItem('locale', value);
            props.compatibilityContext(e, 'blockedLanguage', '', []);
        }
    };

    const q = {
        Products: (
            <>
                <div className="col-4 d-inline-block align-top ml-4 ml-md-0">
                    <p className="mb-3 text-uppercase nav-popup-section-header">{t('Torrent Downloaders')}</p>
                    <div className="tw-group tw-mb-4 tw-mt-6 tw-cursor-pointer tw-text-black tw-duration-300">
                        <p className="tw-mb-2 tw-text-nowrap group-hover:tw-text-link md:tw-text-xl lg:tw-text-4xl">
                            <span className="font-weight-bold bt-font">{isBt ? 'BitTorrent' : 'µTorrent'} </span>
                            {t('Web')}
                        </p>
                        <div
                            className="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-opacity-0 tw-duration-300
                                group-hover:tw-opacity-100 md:tw-text-sm lg:tw-text-lg"
                        >
                            <LocalizedLink
                                id="mainnav-products-btweb-windows"
                                to="/products/win/web-free/"
                                onClick={() => props.togglePopup(null)}
                                className="tw-flex tw-items-center tw-gap-1 tw-no-underline hover:tw-text-link"
                            >
                                <FaWindows />
                                Windows
                            </LocalizedLink>
                            <span className="tw-text-sm tw-font-bold"> | </span>
                            <LocalizedLink
                                id="mainnav-products-btweb-mac"
                                to="/products/mac/web-free/"
                                onClick={() => props.togglePopup(null)}
                                className="tw-flex tw-items-center tw-gap-1 tw-no-underline hover:tw-text-link"
                            >
                                <FaApple />
                                Mac
                            </LocalizedLink>
                        </div>
                    </div>
                    <div className="tw-group tw-my-4 tw-cursor-pointer tw-text-black tw-duration-300">
                        <p className="tw-mb-2 tw-text-nowrap group-hover:tw-text-link md:tw-text-xl lg:tw-text-4xl">
                            <span className="font-weight-bold bt-font">{isBt ? 'BitTorrent' : 'µTorrent'} </span>
                            {t('Classic')}
                        </p>
                        <div
                            className="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-opacity-0 tw-duration-300
                                group-hover:tw-opacity-100 md:tw-text-sm lg:tw-text-lg"
                        >
                            <LocalizedLink
                                id="mainnav-products-btclassic-windows"
                                to="/products/win/classic-free/"
                                onClick={() => props.togglePopup(null)}
                                className="tw-flex tw-items-center tw-gap-1 tw-no-underline hover:tw-text-link"
                            >
                                <FaWindows />
                                Windows
                            </LocalizedLink>
                            {!isBt && (
                                <>
                                    <span className="tw-text-sm tw-font-bold"> | </span>
                                    <a
                                        id="mainnav-products-classicBeta"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="https://download-new.utorrent.com/track/beta/endpoint/utorrent/os/windows"
                                        className="tw-flex tw-items-center tw-gap-1 tw-no-underline hover:tw-text-link"
                                    >
                                        <FaWindows />
                                        Windows Beta
                                    </a>
                                    <span className="tw-text-sm tw-font-bold"> | </span>
                                    <LocalizedLink
                                        id="mainnav-products-btclassic-linux"
                                        to="/downloads/linux/"
                                        onClick={() => props.togglePopup(null)}
                                        className="tw-flex tw-items-center tw-gap-1 tw-no-underline hover:tw-text-link"
                                    >
                                        <FaLinux />
                                        Linux
                                    </LocalizedLink>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="tw-group tw-my-4 tw-cursor-pointer tw-text-black tw-duration-300">
                        <LocalizedLink
                            id="mainnav-products-android"
                            to="/products/android/android-free/"
                            onClick={() => props.togglePopup(null)}
                            className="tw-text-black tw-no-underline tw-duration-300 hover:tw-text-link"
                        >
                            <p className="tw-mb-2 tw-text-nowrap md:tw-text-xl lg:tw-text-4xl">
                                <span className="font-weight-bold bt-font">{isBt ? 'BitTorrent' : 'µTorrent'} </span>
                                {t('Android')}
                            </p>
                        </LocalizedLink>
                        <div
                            aria-hidden="true"
                            className="tw-flex tw-h-7 tw-items-center tw-gap-2 tw-text-xs tw-opacity-0 md:tw-text-sm
                                lg:tw-text-lg"
                        />
                    </div>
                    {isBt && (
                        <div
                            className="tw-group tw-my-4 tw-cursor-pointer tw-text-black tw-duration-300"
                            data-download-path={neoDownloadLink}
                        >
                            <LocalizedLink
                                id="mainnav-products-neo"
                                to={neoProductLink}
                                onClick={() => props.togglePopup(null)}
                                className="tw-text-black tw-no-underline tw-duration-300 hover:tw-text-link"
                            >
                                <p className="tw-mb-2 tw-flex tw-items-center tw-gap-2 tw-text-nowrap md:tw-text-xl lg:tw-text-4xl">
                                    <span>
                                        <span className="font-weight-bold bt-font">BitTorrent </span>
                                        {t('Neo')}
                                    </span>
                                    <span
                                        className="tw-inline-flex tw-h-[22px] tw-items-center tw-rounded-[3px]
                                            tw-bg-brand tw-px-2 tw-text-xs tw-font-normal tw-leading-none tw-text-white"
                                    >
                                        {t('NEW')}
                                    </span>
                                </p>
                            </LocalizedLink>
                            <div
                                className="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-opacity-0 tw-duration-300
                                    group-hover:tw-opacity-100 md:tw-text-sm lg:tw-text-lg"
                            >
                                <LocalizedLink
                                    id="mainnav-products-neo-macos"
                                    to={neoProductLink}
                                    onClick={() => props.togglePopup(null)}
                                    className="tw-flex tw-items-center tw-gap-1 tw-no-underline hover:tw-text-link"
                                >
                                    <FaApple />
                                    macOS
                                </LocalizedLink>
                            </div>
                        </div>
                    )}
                </div>
                <div className="col-4 d-inline-block align-top ml-4 ml-md-0">
                    {isBt && (
                        <>
                            <p className="mb-3 text-uppercase nav-popup-section-header">{t('Decentralized Inference')}</p>
                            <div className="tw-mb-10 tw-mt-6">
                                <a
                                    id="mainnav-products-btfs"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://bttinfergrid.ai/"
                                    onClick={() => props.togglePopup(null)}
                                    className="tw-text-black tw-no-underline tw-duration-300 hover:tw-text-link"
                                >
                                    <p className="tw-text-nowrap md:tw-text-xl lg:tw-text-4xl">
                                        <span className="font-weight-bold bt-font">
                                            {isBt ? 'BitTorrent' : 'µTorrent'}{' '}
                                        </span>
                                        {t('InferGrid')}
                                    </p>
                                </a>
                            </div>
                        </>
                    )}

                    <p className="mb-3 text-uppercase nav-popup-section-header">{t('Content Utility')}</p>
                    <div className="tw-mb-4 tw-mt-6">
                        <a
                            id="mainnav-products-btremote"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={remoteLink}
                            onClick={() => props.togglePopup(null)}
                            className="tw-text-black tw-no-underline tw-duration-300 hover:tw-text-link"
                        >
                            <p className="tw-text-nowrap md:tw-text-xl lg:tw-text-4xl">
                                <span className="font-weight-bold bt-font">{isBt ? 'BitTorrent' : 'µTorrent'} </span>
                                {t('Remote')}
                            </p>
                        </a>
                    </div>
                </div>
            </>
        ),

        Language: (
            <>
                <div className="row">
                    <div className="col-4">
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'en')}
                                to={props.unlocalizedPath}
                                hrefLang="en"
                                id="mainnav-lang-en"
                                className="dropdown-item"
                            >
                                English
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'zh-cn')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/zh-cn' + props.unlocalizedPath
                                }
                                hrefLang="zh_CN"
                                id="mainnav-lang-zh-cn"
                                className="dropdown-item"
                            >
                                中文（简体）
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'zh-tw')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/zh-tw' + props.unlocalizedPath
                                }
                                hrefLang="zh_TW"
                                id="mainnav-lang-zh-tw"
                                className="dropdown-item"
                            >
                                中文（繁體）
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'de')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/de' + props.unlocalizedPath
                                }
                                hrefLang="de"
                                id="mainnav-lang-de"
                                className="dropdown-item"
                            >
                                Deutsch
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'es')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/es' + props.unlocalizedPath
                                }
                                hrefLang="es"
                                id="mainnav-lang-es"
                                className="dropdown-item"
                            >
                                Español
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'fr')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/fr' + props.unlocalizedPath
                                }
                                hrefLang="fr"
                                id="mainnav-lang-fr"
                                className="dropdown-item"
                            >
                                Français
                            </Link>
                        </div>
                    </div>
                    <div className="col-4">
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'hi')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/hi' + props.unlocalizedPath
                                }
                                hrefLang="hi"
                                id="mainnav-lang-hi"
                                className="dropdown-item"
                            >
                                हिन्दी
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'it')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/it' + props.unlocalizedPath
                                }
                                hrefLang="it"
                                id="mainnav-lang-it"
                                className="dropdown-item"
                            >
                                Italiano
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'ja')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/ja' + props.unlocalizedPath
                                }
                                hrefLang="ja"
                                id="mainnav-lang-ja"
                                className="dropdown-item"
                            >
                                日本語
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'ko')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/ko' + props.unlocalizedPath
                                }
                                hrefLang="ko"
                                id="mainnav-lang-ko"
                                className="dropdown-item"
                            >
                                한국어
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'nl')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/nl' + props.unlocalizedPath
                                }
                                hrefLang="nl"
                                id="mainnav-lang-nl"
                                className="dropdown-item"
                            >
                                Nederlands
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'pl')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/pl' + props.unlocalizedPath
                                }
                                hrefLang="pl"
                                id="mainnav-lang-pl"
                                className="dropdown-item"
                            >
                                Polski
                            </Link>
                        </div>
                    </div>
                    <div className="col-4">
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'pt-br')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/pt-br' + props.unlocalizedPath
                                }
                                hrefLang="pt_BR"
                                id="mainnav-lang-pt-br"
                                className="dropdown-item"
                            >
                                Português (Brasil)
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'pt')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/pt' + props.unlocalizedPath
                                }
                                hrefLang="pt"
                                id="mainnav-lang-pt"
                                className="dropdown-item"
                            >
                                Português
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'ru')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/ru' + props.unlocalizedPath
                                }
                                hrefLang="ru"
                                id="mainnav-lang-ru"
                                className="dropdown-item"
                            >
                                Русский
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'tl')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/tl' + props.unlocalizedPath
                                }
                                hrefLang="tl"
                                id="mainnav-lang-tl"
                                className="dropdown-item"
                            >
                                Tagalog
                            </Link>
                        </div>
                        <div>
                            <Link
                                onClick={(e) => handleLanguageClick(e, 'tr')}
                                to={
                                    unlocalizedPageCheck(props.unlocalizedPath)
                                        ? props.unlocalizedPath
                                        : '/tr' + props.unlocalizedPath
                                }
                                hrefLang="tr"
                                id="mainnav-lang-tr"
                                className="dropdown-item"
                            >
                                Türkçe
                            </Link>
                        </div>
                    </div>
                </div>
            </>
        ),
    };

    var test = navContext.selected === null ? navContext.selected : t(navContext.selected);

    return (
        <CSSTransition in={navContext.isPopupOpen} timeout={400} classNames="slide">
            <div className={styles.popup}>
                <div className={styles.popupInner}>
                    <div className="tw-relative tw-mx-auto tw-h-full tw-py-6 sm:tw-max-w-[95%]">
                        <h2
                            className="tw-mb-4 tw-ml-4 tw-mt-6 tw-hidden tw-items-center tw-text-xl tw-font-bold
                                md:tw-text-4xl lg:tw-flex lg:tw-text-5xl xl:tw-my-8"
                        >
                            {test}
                            {navContext.selected === 'Products' && (
                                <span
                                    className="tw-ml-4 tw-h-min tw-border tw-border-neutral-800 tw-px-2 tw-py-1
                                        tw-text-xs tw-font-thin tw-uppercase"
                                >
                                    <LocalizedLink
                                        id="mainnav-products-viewall"
                                        to="/products/"
                                        onClick={() => props.togglePopup(null)}
                                        className="tw-text-black tw-no-underline tw-duration-300 hover:tw-text-link"
                                    >
                                        {t(`View All`)}
                                    </LocalizedLink>
                                </span>
                            )}
                        </h2>
                        {q[`${navContext.selected}`]}
                        <button className={`${styles.close} btn-no-styling`} onClick={() => props.togglePopup(null)}>
                            <IoMdClose />
                        </button>
                    </div>
                </div>
            </div>
        </CSSTransition>
    );
};

export default NavPopup;
